/* eComHQ cart drawer (owner rule, October 7, 2026). Shared behaviour for every store; installed as assets/ehq-cart-drawer.js by shopify/cart-drawer/apply.py.
   The drawer keeps itself current by reading every Shopify Ajax cart response the page receives, so a theme only has to open it:
   window.EHQCart.open(), or any element with data-ehq-cart-open. A theme that still has its own older drawer names it in data-legacy and this drawer opens in its place. */
(function () {
  'use strict';
  var root = document.querySelector('[data-ehq-cart]');
  if (!root || window.EHQCart || typeof root.showModal !== 'function') return;

  var cfg = root.dataset, base = (cfg.root || '/').replace(/\/$/, '') + '/';
  var seed = {};
  try { seed = JSON.parse(document.querySelector('[data-ehq-data]').textContent); } catch (e) {}
  var compare = seed.compare || {}, cart = null, seenAt = 0, lookedUp = {};
  var nativeFetch = window.fetch;
  var $ = function (s) { return root.querySelector(s); };

  function money(cents, currency) { return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency || 'USD' }).format(cents / 100); }
  function short(cents, currency) { return money(cents, currency).replace(/\.00$/, ''); }
  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }

  // Same date as the alert bar: the offer runs until tomorrow.
  function saleEnds() {
    var d = new Date(); d.setDate(d.getDate() + 1);
    var n = d.getDate(), t = n % 100, suffix = t >= 11 && t <= 13 ? 'th' : ({ 1: 'st', 2: 'nd', 3: 'rd' }[n % 10] || 'th');
    return d.toLocaleString('en-US', { month: 'short' }) + ' ' + n + suffix;
  }

  // cart.js has no compare-at price. The page supplies it for the store's products; any other variant is looked up once.
  function lookUp(item) {
    if (lookedUp[item.handle] || !item.handle) return;
    lookedUp[item.handle] = true;
    nativeFetch.call(window, base + 'products/' + encodeURIComponent(item.handle) + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
      if (!p) return;
      p.variants.forEach(function (v) { compare[v.id] = v.compare_at_price || 0; });
      if (cart) render(cart);
    }).catch(function () {});
  }

  function line(item, currency) {
    if (!(item.variant_id in compare)) lookUp(item);
    var was = compare[item.variant_id] || 0, onSale = was > item.final_price;
    var row = el('li', 'ehq-line');

    var media = el('a', 'ehq-line__media'); media.href = item.url; media.tabIndex = -1; media.setAttribute('aria-hidden', 'true');
    var src = (item.featured_image && item.featured_image.url) || item.image;
    if (src) { var img = el('img'); img.src = src + (src.indexOf('?') < 0 ? '?' : '&') + 'width=176'; img.alt = ''; img.width = 72; img.height = 72; media.append(img); }
    if (onSale) media.append(el('span', 'ehq-line__ribbon', 'Sale'));

    var info = el('div', 'ehq-line__info'), name = el('p', 'ehq-line__name'), link = el('a', '', item.product_title);
    link.href = item.url; name.append(link); info.append(name);
    if (item.variant_title && item.variant_title !== 'Default Title') info.append(el('p', 'ehq-line__variant', item.variant_title));
    var price = el('p', 'ehq-line__price');
    if (onSale) price.append(el('s', '', short(was, currency)));
    price.append(el('b', '', short(item.final_price, currency)));
    info.append(price);
    if (onSale && cfg.note) info.append(el('p', 'ehq-line__note', cfg.note));

    var ctl = el('div', 'ehq-line__ctl'), qty = el('input', 'ehq-line__qty');
    qty.type = 'number'; qty.min = 1; qty.max = 99; qty.inputMode = 'numeric'; qty.value = item.quantity;
    qty.setAttribute('aria-label', 'Quantity for ' + item.product_title);
    qty.addEventListener('change', function () { change(item.key, Math.max(1, Math.min(99, Math.round(+qty.value) || 1))); });
    var remove = el('button', 'ehq-line__remove', 'Remove'); remove.type = 'button';
    remove.setAttribute('aria-label', 'Remove ' + item.product_title);
    remove.addEventListener('click', function () { change(item.key, 0); });
    ctl.append(qty, remove);

    row.append(media, info, ctl);
    return { row: row, onSale: onSale };
  }

  function render(c) {
    var lines = $('[data-ehq-lines]'), anySale = false;
    lines.replaceChildren();
    c.items.forEach(function (item) { var l = line(item, c.currency); anySale = anySale || l.onSale; lines.append(l.row); });
    var state = !c.item_count ? 'empty' : anySale ? 'sale' : 'plain';
    root.dataset.state = state;
    root.querySelectorAll('[data-ehq-when]').forEach(function (n) { n.hidden = n.dataset.ehqWhen.split(' ').indexOf(state) < 0; });
    $('[data-ehq-total]').textContent = money(c.total_price, c.currency) + ' ' + (c.currency || 'USD');
    $('[data-ehq-date]').textContent = saleEnds();
    if (cfg.count) document.querySelectorAll(cfg.count).forEach(function (n) {
      n.textContent = c.item_count || cfg.countZero === 'zero' ? c.item_count : '';
      if (cfg.countZero === 'hide') n.hidden = !c.item_count;
      if (n.hasAttribute('data-n')) n.dataset.n = c.item_count;
    });
  }

  function remember(c) { if (!c || !Array.isArray(c.items)) return; cart = c; seenAt = Date.now(); render(c); }
  function setError(text) { $('[data-ehq-error]').textContent = text || ''; }
  function refresh() { return nativeFetch.call(window, base + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(remember).catch(function () {}); }

  function change(key, quantity) {
    root.classList.add('is-busy');
    nativeFetch.call(window, base + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: quantity }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw Error(j.description || j.message || 'Please try again.'); return j; }); })
      .then(function (j) { setError(''); remember(j); })
      .catch(function (e) { setError(e.message); if (cart) render(cart); })
      .then(function () { root.classList.remove('is-busy'); });
  }

  // Add to Cart spinner (owner rule, October 8, 2026): the button that was pressed shows a spinner from the add request until this drawer opens.
  // It works from the request, not from a theme hook, so it covers the main, sticky and quick-add buttons of any theme.
  var pressed = null, pressedAt = 0, adding = null, addingTimer = 0;
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button,input[type=submit],[role=button],a');
    if (b && !root.contains(b)) { pressed = b; pressedAt = Date.now(); }
  }, true);
  function spin() {
    if (adding || !pressed || !pressed.isConnected || Date.now() - pressedAt > 1500) return;
    var style = getComputedStyle(pressed);
    adding = { button: pressed, position: pressed.style.position };
    pressed.style.setProperty('--ehq-spin', style.color);
    if (style.position === 'static') pressed.style.position = 'relative';
    pressed.classList.add('ehq-adding');
    pressed.setAttribute('aria-busy', 'true');
    addingTimer = setTimeout(unspin, 15000);
  }
  function unspin() {
    if (!adding) return;
    clearTimeout(addingTimer);
    var b = adding.button;
    b.classList.remove('ehq-adding'); b.removeAttribute('aria-busy');
    b.style.removeProperty('--ehq-spin'); b.style.position = adding.position;
    adding = null;
  }

  // Every cart response the theme's own code receives also updates this drawer. The request and its result are left untouched.
  window.fetch = function (input) {
    var promise = nativeFetch.apply(window, arguments);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      // A failed add opens no drawer, so the spinner ends with the request.
      if (/\/cart\/add(\.js)?(\?|$)/.test(url)) { spin(); promise.then(function (r) { if (!r.ok) unspin(); }, unspin); }
      if (/\/cart(\/(change|update|clear))?\.js(\?|$)/.test(url)) promise.then(function (r) { if (r.ok) r.clone().json().then(remember, function () {}); }, function () {});
    } catch (e) {}
    return promise;
  };

  function open() {
    if (cart) render(cart);
    if (!root.open) root.showModal();
    unspin();
    document.body.classList.add('ehq-cart-open');
    if (Date.now() - seenAt > 2000) refresh();
  }
  function close() { if (root.open) root.close(); }
  root.addEventListener('close', function () { document.body.classList.remove('ehq-cart-open'); });
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-ehq-close]')) return close();
    if (e.target !== root) return;
    var b = root.getBoundingClientRect();
    if (e.clientX < b.left || e.clientX > b.right || e.clientY < b.top || e.clientY > b.bottom) close();
  });
  document.addEventListener('click', function (e) { if (e.target.closest('[data-ehq-cart-open]')) { e.preventDefault(); open(); } });

  // A theme's older drawer: the moment the theme opens it, close it the theme's own way and show this one.
  var legacy = cfg.legacy && document.querySelector(cfg.legacy);
  if (legacy) {
    var isDialog = legacy.tagName === 'DIALOG';
    var legacyOpen = function () { return isDialog ? legacy.open : legacy.classList.contains(cfg.legacyOpenClass || 'is-open'); };
    new MutationObserver(function () {
      if (!legacyOpen()) return;
      if (isDialog) legacy.close(); else { var b = legacy.querySelector(cfg.legacyClose || '[data-close]'); if (b) b.click(); }
      if (!legacyOpen()) open();
    }).observe(legacy, { attributes: true, attributeFilter: ['open', 'class'] });
    if (cfg.legacyError) document.querySelectorAll(cfg.legacyError).forEach(function (n) {
      new MutationObserver(function () { setError(n.textContent); }).observe(n, { childList: true, characterData: true, subtree: true });
    });
  }

  window.EHQCart = { open: open, close: close, refresh: refresh, render: remember };
  // The page's own copy of the cart may be a cached render, so the first open still asks Shopify.
  if (seed.cart) { remember(seed.cart); seenAt = 0; }
})();
